import User from '../entity/User';

class IntercomService {
  private getIntercom: () => any;
  private appId: string;
  private isBooted: boolean;

  constructor(getIntercom: () => any, appId: string) {
    this.getIntercom = getIntercom;
    this.appId = appId;
    this.isBooted = false;
  }

  public identify = (user: User) => {
    this.bootOrUpdate({
      app_id: this.appId,
      user_id: user.id,
      name: user.name,
      email: user.email,
    });
  };

  public anonymize = () => {
    this.bootOrUpdate({
      app_id: this.appId,
    });
  };

  public openNewMessage = (defaultBody?: string) => {
    this.getIntercom()('showNewMessage', defaultBody);
  };

  private bootOrUpdate = (...args: any[]) => {
    this.getIntercom()(this.isBooted ? 'update' : 'boot', ...args);

    this.isBooted = true;
  };
}

export default IntercomService;
